import { render } from "./DeviceLastSeenCell.vue?vue&type=template&id=2f038c76"
import script from "./DeviceLastSeenCell.vue?vue&type=script&lang=js"
export * from "./DeviceLastSeenCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__